import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet } from "react-router-dom";
import {
  readMembershipsForProduct,
  readSuperUser,
  reconcileActiveOrg,
} from "../utils/activeOrg";

export const AuthLayout = () => {
  const { isLoading, isAuthenticated, loginWithRedirect, user } = useAuth0();

  // Reconciled here, before <Outlet /> renders anything that fetches. The
  // request layer reads the stored organization at call time, so a stale value
  // would go out on the very first call and come back 403 - including on the
  // endpoint that lists the valid organizations, leaving no way back. Reading
  // memberships off the token rather than from an API call is what avoids that
  // deadlock.
  //
  // Deliberately during render rather than in an effect: a parent's effect runs
  // AFTER its children have rendered and fired their own effects, so an effect
  // here would land after the first requests had already gone out with the stale
  // value. It is idempotent, so React's double-render in development is
  // harmless.
  if (isAuthenticated) {
    reconcileActiveOrg(readMembershipsForProduct(user), {
      superUser: readSuperUser(user),
    });
  }

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect({
        appState: {
          returnTo: window.location.pathname + window.location.search,
        },
      });
    };
    fn();
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  return isAuthenticated ? <Outlet /> : null;
};
